import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";
import { Result } from "../../../shared/model/response.model"
import { DataService } from "../../../shared/services/data.service";
import { AddEditCategoriesRequestmodel, AddInventoryCategoriesRequestmodel, getAllCategory, InventoryCategoriesDelete, statusUpdate } from './inventory-categories.model';
@Injectable({
  providedIn: 'root'
})
export class InventoryCategoriesService {
   
  public  inventoryPageChanged = new Subject<string>();
  public isEdited:boolean=false;
  constructor(public router: Router,public service: DataService,) { }
  private deleteNodeSource = new Subject<any>();
  deleteNode$ = this.deleteNodeSource.asObservable();
  triggerDeleteNode(data: any): void {
    this.deleteNodeSource.next(data);
  }
  //  Add Inventory Categories
  addInventorysCategories(addInventoryCategoriesRequestmodel: AddInventoryCategoriesRequestmodel): Observable<Result> {
    let url = "app/inventoryCategories/addInventoryCategoryPopup";
    return this.service.post(url, addInventoryCategoriesRequestmodel, true).pipe<Result>(tap((response: any) => {
      return response;
    })
    );
  }

  // Get All category List
  getAllCategoryList(inventoryCategory: getAllCategory): Observable<Result> {
    let url = "app/inventoryCategories/getAllCategory";
    return this.service.post(url, inventoryCategory, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  // Delete Inventory Categories

  deleteCategory(CategoriesId : InventoryCategoriesDelete) : Observable<Result>{
    let url = "app/inventoryCategories/deleteInventoryCategories";
    return this.service.post(url, CategoriesId).pipe(tap((response: any) => {
      return response;
    }))
  }

  // Status Update Inventory Categories

  statusUpdateCategory(data:statusUpdate) : Observable<Result>{
    let url = "app/inventoryCategories/updateInventoryCategoryStatus";
    return this.service.post(url, data).pipe(tap((response: any) => {
      return response;
    }))
  }

  addUpdateInventoryCategories(addEditCategoriesRequestmodel: AddEditCategoriesRequestmodel): Observable<Result> {
    let url = "app/inventoryCategories/addUpdateInventoryCategories";
    return this.service.post(url, addEditCategoriesRequestmodel, true).pipe<Result>(tap((response: any) => {
      return response;
    })
    );
  }

  addParentCategory(addInventoryCategoriesRequestmodel: AddInventoryCategoriesRequestmodel): Observable<Result> {
    let url = "app/inventoryCategories/insertUpdateParentCategory";
    return this.service.post(url, addInventoryCategoriesRequestmodel, true).pipe<Result>(tap((response: any) => {
      return response;
    })
    );
  }

}
